export interface Team {
  code: string;
  name: string;
  group: string;
  /** Códigos explícitos das figurinhas. Se ausente, gera `${code}1..STICKERS_PER_TEAM`. */
  codes?: string[];
  /** Se a seção entra na contagem total do álbum. Default true. */
  countsTowardTotal?: boolean;
}

export const STICKERS_PER_TEAM = 20; // 1 escudo + 19 jogadores
export const COCA_COLA_COUNT = 14;

export const TEAMS: Team[] = [
  // Grupo A
  { code: 'MEX', name: 'México',               group: 'A' },
  { code: 'RSA', name: 'África do Sul',        group: 'A' },
  { code: 'KOR', name: 'Coreia do Sul',        group: 'A' },
  { code: 'CZE', name: 'República Tcheca',     group: 'A' },
  // Grupo B
  { code: 'CAN', name: 'Canadá',               group: 'B' },
  { code: 'BIH', name: 'Bósnia e Herzegovina', group: 'B' },
  { code: 'QAT', name: 'Catar',                group: 'B' },
  { code: 'SUI', name: 'Suíça',                group: 'B' },
  // Grupo C
  { code: 'BRA', name: 'Brasil',               group: 'C' },
  { code: 'MAR', name: 'Marrocos',             group: 'C' },
  { code: 'HAI', name: 'Haiti',                group: 'C' },
  { code: 'SCO', name: 'Escócia',              group: 'C' },
  // Grupo D
  { code: 'USA', name: 'Estados Unidos',       group: 'D' },
  { code: 'PAR', name: 'Paraguai',             group: 'D' },
  { code: 'AUS', name: 'Austrália',            group: 'D' },
  { code: 'TUR', name: 'Turquia',              group: 'D' },
  // Grupo E
  { code: 'GER', name: 'Alemanha',             group: 'E' },
  { code: 'CUW', name: 'Curaçao',              group: 'E' },
  { code: 'CIV', name: 'Costa do Marfim',      group: 'E' },
  { code: 'ECU', name: 'Equador',              group: 'E' },
  // Grupo F
  { code: 'NED', name: 'Holanda',              group: 'F' },
  { code: 'JPN', name: 'Japão',                group: 'F' },
  { code: 'SWE', name: 'Suécia',               group: 'F' },
  { code: 'TUN', name: 'Tunísia',              group: 'F' },
  // Grupo G
  { code: 'BEL', name: 'Bélgica',              group: 'G' },
  { code: 'EGY', name: 'Egito',                group: 'G' },
  { code: 'IRN', name: 'Irã',                  group: 'G' },
  { code: 'NZL', name: 'Nova Zelândia',        group: 'G' },
  // Grupo H
  { code: 'ESP', name: 'Espanha',              group: 'H' },
  { code: 'CPV', name: 'Cabo Verde',           group: 'H' },
  { code: 'KSA', name: 'Arábia Saudita',       group: 'H' },
  { code: 'URU', name: 'Uruguai',              group: 'H' },
  // Grupo I
  { code: 'FRA', name: 'França',               group: 'I' },
  { code: 'SEN', name: 'Senegal',              group: 'I' },
  { code: 'IRQ', name: 'Iraque',               group: 'I' },
  { code: 'NOR', name: 'Noruega',              group: 'I' },
  // Grupo J
  { code: 'ARG', name: 'Argentina',            group: 'J' },
  { code: 'ALG', name: 'Argélia',              group: 'J' },
  { code: 'AUT', name: 'Áustria',              group: 'J' },
  { code: 'JOR', name: 'Jordânia',             group: 'J' },
  // Grupo K
  { code: 'POR', name: 'Portugal',             group: 'K' },
  { code: 'COD', name: 'RD Congo',             group: 'K' },
  { code: 'UZB', name: 'Uzbequistão',          group: 'K' },
  { code: 'COL', name: 'Colômbia',             group: 'K' },
  // Grupo L
  { code: 'ENG', name: 'Inglaterra',           group: 'L' },
  { code: 'CRO', name: 'Croácia',              group: 'L' },
  { code: 'GHA', name: 'Gana',                 group: 'L' },
  { code: 'PAN', name: 'Panamá',               group: 'L' },
];

// Especiais Copa 2026 — 3 sub-seções, todas usam prefixo FWC nos códigos
export const FWC_SECTIONS: Team[] = [
  {
    code: 'FWC_COPA',
    name: 'Copa 2026',
    group: 'ESPECIAIS',
    codes: ['FWC00', 'FWC1', 'FWC2', 'FWC3', 'FWC4'],
  },
  {
    code: 'FWC_BOLAS',
    name: 'Bolas e Países-Sede',
    group: 'ESPECIAIS',
    codes: ['FWC5', 'FWC6', 'FWC7', 'FWC8'],
  },
  {
    code: 'FWC_HIST',
    name: 'História da Copa',
    group: 'ESPECIAIS',
    codes: Array.from({ length: 11 }, (_, i) => `FWC${i + 9}`), // FWC9..FWC19
  },
];

// Extras — dourado/prata/bronze/regular. Não entram na contagem do álbum.
export const EXTRAS_TEAM: Team = {
  code: 'EXTRAS',
  name: 'Extra Stickers',
  group: 'EXTRAS',
  codes: ['REGU', 'BRON', 'PRAT', 'OURO'],
  countsTowardTotal: false,
};

export const EXTRAS_LABELS: Record<string, string> = {
  REGU: 'Regular',
  BRON: 'Bronze',
  PRAT: 'Prata',
  OURO: 'Ouro',
};

export const COCA_COLA_TEAM: Team = {
  code: 'CC',
  name: 'Coca-Cola',
  group: 'COCA-COLA',
  countsTowardTotal: false,
};

export const ALL_TEAMS: Team[] = [
  ...TEAMS,
  ...FWC_SECTIONS,
  EXTRAS_TEAM,
  COCA_COLA_TEAM,
];

export function getTeamStickerCodes(teamCode: string): string[] {
  const team = ALL_TEAMS.find((t) => t.code === teamCode);
  if (team?.codes) return team.codes;
  if (teamCode === 'CC') {
    return Array.from({ length: COCA_COLA_COUNT }, (_, i) => `CC${i + 1}`);
  }
  return Array.from({ length: STICKERS_PER_TEAM }, (_, i) => `${teamCode}${i + 1}`);
}

/** Códigos que entram na contagem total do álbum. */
export function getAllStickerCodes(): string[] {
  const codes: string[] = [];
  for (const team of TEAMS) {
    for (let i = 1; i <= STICKERS_PER_TEAM; i++) codes.push(`${team.code}${i}`);
  }
  for (const sec of FWC_SECTIONS) {
    if (sec.codes) codes.push(...sec.codes);
  }
  return codes;
}

/** Códigos válidos para troca/cruzamento com amigos. Inclui CC (fora da contagem do álbum). */
export function getAllTradeableStickerCodes(): string[] {
  return [...getAllStickerCodes(), ...getTeamStickerCodes('CC')];
}

const FWC_TOTAL = FWC_SECTIONS.reduce((sum, s) => sum + (s.codes?.length ?? 0), 0);

export const TOTAL_STICKERS = TEAMS.length * STICKERS_PER_TEAM + FWC_TOTAL;
